/* import __COLOCATED_TEMPLATE__ from './navigation.hbs'; */
/**

## Selector Navigation

**Contextual Component** This component is not intended to be used as a standalone. Checkout it's potential parent components for usage instead:
[Selector Control](../selector-control.html)

The Selector Navigation component is the parent component wrapping a set of clickable elements that can serve
as navigation to switch between multiple pieces of content within a single page. It supports 3 different UI
patterns: [Tabs](./navigation/item/tab.html),
[Steps (Breadcrumbs)](./navigation/item/step.html),
or [Segments](./navigation/segmented-control.html)

Selector Navigation uses contextual components

### Contextual Components

| Description | Contextual Component |
| --- | --- |
| Item | [Selector Control Navigation item](./navigation/item.html) |
| Button | [Selector Control Navigation Button](./navigation/button.html) |

### Parameters
@param {String} [type='TAB'] Determines the UI type of this element. `TAB`, `STEP`, or `SEGMENT` (Note: there is no need to pass this property as it is set by the type of components passed to it's block)

**/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { SELECTOR_TYPE } from './navigation/item';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'nav',
  classNames: ['selector-control__navigation'],
  classNameBindings: ['navTypeClass'],
  attributeBindings: ['data-test-selector-control-navigation'],
  'data-test-selector-control-navigation': true,
  type: SELECTOR_TYPE.TAB,
  navTypeClass: computed('type', function () {
    switch (this.get('type')) {
      case SELECTOR_TYPE.STEP:
        return 'breadcrumbs';
      case SELECTOR_TYPE.TAB:
        return 'tab-set';
      case SELECTOR_TYPE.SEGMENT:
        return 'segmented-control';
      default:
        return '';
    }
  }),
  actions: {
    onSelectItem(item) {
      this.onSelectItem(item);
    },
    navigate(direction) {
      this.onNavigate(direction);
    }
  }
});